import { Component, OnInit } from "@angular/core";
import { BlobService } from "@merri/common";
import { environment } from "src/environments/environment";

@Component({
    selector: "app-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    standalone: false
})
export class HeaderComponent implements OnInit {
  title: string;
  logo: string;
  isProd: boolean = environment.production;

  constructor(private blobService: BlobService) {}

  ngOnInit() {
    this.logo = this.blobService.getAssetBlobUrl("wordmark_primary_black.svg");
  }
}
